// Verify2FAHandler.jsx
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Auth, cqAPI } from "../../lib/Auth";

export default function Verify2FAHandler() {
  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");
  const code = searchParams.get("code");
  const trustDevice = searchParams.get("trustDevice") ?? false;
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {

    const handleVerify = async () => {
      try {
        const response = await cqAPI.post(`/verify-2fa?uid=${uid}&code=${code}&trustDevice=${trustDevice}`);
        if (response.type === "ok") {
          // 2FA success. Store user data, token, etc.
          Auth.storeUser(response.data.user);
          if (response.data.rememberMeToken) {
            localStorage.setItem('rememberMeToken', response.data.rememberMeToken);
          }
          navigate("/dashboard");
        } else {
          setError(response.msg || "Code is incorrect or expired.");
          console.error(response.msg || "Code is incorrect or expired.");
        }
      } catch (err) {
        setError(err.message || "Something went wrong.")
        console.error(err.message || "Something went wrong.");
      }
    };

    if (uid && code) {
      handleVerify();
    }
  }, []);

  return (
    <div>
      Verifying your device, please wait...
      {error && (
        <div style={{ color: "red", marginTop: "1rem" }}>
          Error: {error}
        </div>
      )}
    </div>
  );
}
